import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import {Divider, Stack} from '@mui/material';
import {FC} from 'react';
import {useStepsFormContext} from '../../contexts';
import {useStepperStore} from '../../store/useStepperStore';
import {StepForm} from '../step-form';
import {Stepper} from '../stepper';
import {STYLES} from './styles';

export const Editor: FC = () => {
  const selectedStepId = useStepperStore((s) => s.selectedStepId);
  const {watch} = useStepsFormContext();
  const steps = watch('steps');

  return (
    <Stack direction="row">
      <Stack minWidth={250} maxWidth={250}>
        <Stepper />
      </Stack>
      <Divider orientation="vertical" flexItem sx={STYLES.divider} />
      <Stack width="100%" gap={3}>
        <TabContext value={selectedStepId ?? ''}>
          {steps.map((step) => (
            <TabPanel key={step.id} value={step.id} sx={STYLES.tabPanel}>
              <StepForm />
            </TabPanel>
          ))}
        </TabContext>
      </Stack>
    </Stack>
  );
};
